// extracted by mini-css-extract-plugin
export default {"cell":"AutoPayCell_cell__Uq-72"};